// @ts-nocheck
// oxlint-disable no-unused-vars
import type {
	ApiResponseOfAuthResponse,
	ConfirmEmailRequest,
	LoginRequest,
	RefreshTokenRequest,
	RegisterUserRequest,
	RequestPasswordResetRequest,
	ResetPasswordRequest,
} from "../types";
import { apiFetch, type ApiResponse } from "@/api/fetch";

/** Auto-generated file. Do not edit. */

/**
 * POST `/auth/email/confirm`
 */
export const postApiAuthEmailConfirm = (data: ConfirmEmailRequest) =>
	apiFetch<ApiResponse<null>>({
		uri: "auth/email/confirm",
		method: "POST",
		body: data,
	});

/**
 * POST `/auth/login`
 */
export const postApiAuthLogin = (data: LoginRequest) =>
	apiFetch<ApiResponseOfAuthResponse>({
		uri: "auth/login",
		method: "POST",
		body: data,
	});

/**
 * POST `/auth/password/reset`
 */
export const postApiAuthPasswordReset = (data: ResetPasswordRequest) =>
	apiFetch<ApiResponse<null>>({
		uri: "auth/password/reset",
		method: "POST",
		body: data,
	});

/**
 * POST `/auth/password/reset/request`
 */
export const postApiAuthPasswordResetRequest = (data: RequestPasswordResetRequest) =>
	apiFetch<ApiResponse<null>>({
		uri: "auth/password/reset/request",
		method: "POST",
		body: data,
	});

/**
 * POST `/auth/refresh`
 */
export const postApiAuthRefresh = (data: RefreshTokenRequest) =>
	apiFetch<ApiResponseOfAuthResponse>({
		uri: "auth/refresh",
		method: "POST",
		body: data,
	});

/**
 * POST `/auth/register`
 */
export const postApiAuthRegister = (data: RegisterUserRequest) =>
	apiFetch<ApiResponseOfAuthResponse>({
		uri: "auth/register",
		method: "POST",
		body: data,
	});
